/* 🤖 this file was generated by script */
export const wiconApprovePathSetting = {
  name: 'approve_path_setting',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 10h-.19M5 8v-.19M5 12v.21M7 10h3m0 0a1 1 0 112 0m-2 0a1 1 0 102 0m0 0h3m0 0a1 1 0 112 0 1 1 0 01-2 0zM3.54 8.54l-.1-.1m.1 3.02l-.1.1m3.02-.1l.1.1m-.1-3.02l.1-.1"/><circle cx="5" cy="10" r="1.68" fill="none" stroke="currentColor"/></svg>`,
};
